export default host => (token, type = "music") =>`${host}/public/playlists/${token}/downloadZip?type=${type}`
